export default __webpack_public_path__ + "static/media/efective.fd4d8378.svg";